module.exports = __webpack_public_path__ + "img/loginBgc.159fce5d.jpg";